<template>
  <div class="dayi_warp">
    <div class="back">
      <img src="@/static/back1.png"
           @click="back"
           alt="">
      <!-- <div @click="add">
        发帖
      </div> -->
    </div>
    <div class="subjects">
      <div class="item_wrap"
           v-for="item in subjectList"
           :key="item.board_id">
        <div class="item"
             @click="checkSubject(item)">
          <div :class="{'active1': discuss_board == item.board_id,'icon':true}">
            <img :src="require('@/static/subject/'+images[item.board_id].img+'.png')"
                 alt="">
                 <div class="text">
            {{item.board_name}}
          </div>
          </div>
           
        </div>
      </div>
    </div>
    <div class="status_line">
      <div :class="{'status':true,'active':status == item.id}"
           v-for="item in statusList"
           :key="item.label"
           @click="changeStatus(item)">{{item.label}}
      </div>
      <div class="search">
        <div class="btn"
             @click="add">
              <div> <img src="@/static/subject/发帖.png"
             alt=""></div>
          <div>发帖</div>
        </div>
                   <div class="btn"
             @click="search">
              <div> <img src="@/static/subject/搜索.png"
             alt=""></div>
          <div>查询</div>
        </div>
      </div>
     
    </div>
    <div class="list">
      <!-- v-for="item in List" -->
      <div class="post_item"
           v-for='item in showList'
           @click="toInfo(item)"
           :key="item.discuss_id">
            <div class="tab" :style="{ background: boardBackg[item.board_id]?.background }">
            {{item.board_name}}
          </div>
        <div class="head">
          <span>
            {{item.discuss_title}}
          </span>
          
        </div>
        <div class="content">
          {{item.discuss_content}}
        </div>
        <div class="image"
             v-if="item.discuss_image &&JSON.parse(item.discuss_image).length">
          <img :src="item.discuss_image && JSON.parse(item.discuss_image)[0]"
               alt="">
        </div>
        <div class="opertion">
          <div class="right">
            {{item.discuss_time}}
         
          </div>
          <div class="left">
            <img src="@/static/dayi/like.png"
                 alt="">
            {{item.discuss_upvote_times}}
            <img src="@/static/dayi/评论.png"
                 style="margin-left:25rem"
                 alt="">
            {{item.discuss_re_times}}
            <div @click.stop="deleteDiscuss(item)" v-show="status=='1'" style="align-items: center;display: flex;margin-left: 26rem;">
               <img src="@/static/subject/Trash.png"
                 
                 alt="">
            删除
            </div>
          </div>
           
        </div>
      </div>

    </div>
    <!-- <div class='page'>
      <a-pagination :current="current1"
                    :pageSize="pageSize1"
                    show-size-changer
                    :total="totalEle"
                    show-quick-jumper
                    @change="onShowSizeChange"
                    :show-total="total => `总共 ${totalEle} 条`"
                    @showSizeChange="onShowSizeChange" />
    </div> -->
    <!-- 发帖弹出框 -->
    <Form ref="FormRef"
          type='1'
          v-if="active"
          :subjectList='subjectList'
          @submit="submit"
          @cancel='cancel' />
    <!--搜索弹出框  -->
    <formDialog ref="formDialogRef"
                @getData='getList'
                v-else />

  </div>
</template>

<script setup>
import formDialog from '@/views/components/COMMON_TOP_SEARCH/search.vue'
import Form from './components/form.vue'
import { message ,Modal} from 'ant-design-vue'
import { useRouter, onBeforeRouteLeave } from 'vue-router'
import { images, statusList,boardBackg } from './property'
import { nextTick, onUnmounted, ref, watch, onMounted } from 'vue'
import { getDiscussBoard, getDiscussList, addPost,deletePost } from '@/api/post.js'

// let idx = ref('')
//let weishenhe = ref(true)
let router = useRouter()
let totalEle = ref(0)
let keywords = ref('')
let subjectList = ref([])
let status = ref(0)
let discuss_board = ref('')
let List = ref([])
let showList = ref([])

const pageSize1 = ref(10);//每页条数
const current1 = ref(1);//当前页数

const onShowSizeChange = (current, pageSize) => {
  let start = pageSize * (current - 1)
  let end = pageSize * current
  current1.value = current
  pageSize1.value = pageSize
  showList.value = List.value.slice(start, end)
};

// 判断哪个弹出框显示
let active = ref(false)

let formDialogRef = ref()
let FormRef = ref()


// 获取帖子内容板块
let getSubject = async () => {
  const { data } = await getDiscussBoard()
  subjectList.value = data
  if (window.sessionStorage.getItem('postBoard')) {
    discuss_board.value = window.sessionStorage.getItem('postBoard')
  }
  else { discuss_board.value = data[0].board_id }

  getList()
}

//获取帖子数据
let getList = async (keyword) => {
  List.value = []
  keywords.value = keyword
  const { data } = await getDiscussList({
    discuss_board: discuss_board.value,
    discuss_post_type: status.value,
    search: keywords.value
  })
  keywords.value = ''
  List.value = data.volist
  totalEle.value = data.volist.length
  showList.value = data.volist
  // onShowSizeChange(current1.value, pageSize1.value)
}
let checkSubject = (item) => {
  discuss_board.value = item.board_id
  current1.value = 1
  getList()
}
let back = () => {
  router.go(-1)
}

let changeStatus = (item) => {
  status.value = item.id
  current1.value = 1
  getList()
}
//搜索按钮，出现弹窗
let search = () => {
  active.value = false
  nextTick(() => {
    formDialogRef.value.keywords = keywords.value
    formDialogRef.value.dialogVisible = true
  })
}
//点击帖子条目跳转
let toInfo = (item) => {
  let form = {
    status: status.value
  }
  if (status.value == 2) {
    form.discuss_id = item.discuss_parent_id
  } else {
    form.discuss_id = item.discuss_id
  }
  router.push('/dayi/info?form=' + JSON.stringify(form))
}
//点击发帖
let add = () => {
  let form = {
    discuss_title: '',
    discuss_content: '',
    board_id: Number(discuss_board.value),
    question_id: '',
    discuss_image: []
  }
  active.value = true
  nextTick(() => {
    FormRef.value.form = form
    FormRef.value.dialogVisible = true
  })
}
const deleteDiscuss = async (item) => {
  let form = {
        discuss_id : item.discuss_id
  }
     Modal.confirm({
      title: '提示',
      content: '是否删除帖子，删除后不可恢复',
      async onOk () {

   const { status } = await deletePost(
form
  )
  // console.log(FormRef.value.form1)
  message.success('删除成功')
  // cancel()
  getList()
      },
      onCancel () {
         
      },
    });
 
}
//发帖弹窗》提交
const submit = async () => {
  const { status } = await addPost(
    FormRef.value.form1
  )
  // console.log(FormRef.value.form1)
  message.success('发帖成功')
  cancel()
  getList()
}
//发帖弹窗》取消
const cancel = () => {
  FormRef.value.dialogVisible = false
}

onMounted(() => {
  getSubject()

})
onBeforeRouteLeave((to, from, next) => {
  if (to.name == '/dayi/info') {
    window.sessionStorage.setItem('postBoard', discuss_board.value)
  } else {
    window.sessionStorage.removeItem('postBoard')
  }
  next()
})


</script>

<style lang="scss" scoped>
.dayi_warp {
  width: 100%;
  height: 100vh;

  overflow-x: hidden;
  background-image: url("../../static/allBackg/线上答疑.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.back {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30rem;
  padding: 0 40rem;
  img {
    width: 60rem;
    height: 60rem;
    cursor: pointer;
  }
  div {
    background-color: #3e8ef3;
    border-radius: 35rem;
    font-size: 32rem;
    font-weight: 700;
    padding: 6rem 43rem;
    background: #1372e9;
    color: white;
    cursor: pointer;
  }
}

.subjects {
  display: flex;
  display: flex;
  padding-bottom: 20rem;
  padding-top: 40rem;
  overflow: auto;
  // margin-top: 40rem;
  // background: #3fa2ff;
  // justify-content: center;
  .item_wrap {
    margin: 0 auto;
    padding: 0 20rem;
  }
  .item {
    cursor: pointer;
    .icon {
      .text {
      text-align: center;
      font-weight: 600;
      color: #ffffff;
      font-size: 24rem;
      margin-top: 10rem;
      flex-shrink: 0;
      margin-top: 5rem;
    }
 
display: flex;
width:120rem;
height: 120rem;
// padding: 20rem 16rem;
flex-direction: column;
justify-content: center;
align-items: center;
flex-shrink: 0;
      &:hover {
        // border: 1rem solid #b7dcff;
      }
      img {
        width: 45rem;
        height: 45rem;
      }
    }
     
  }
  .active1 {
    // border: 1rem solid #b7dcff !important;
         border-radius: 24rem;
background: rgba(245, 245, 245, 0.20);
box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.10);
  }
}
.status_line {
  display: flex;
  // justify-content: center;
  // margin-top: 15rem;
  border-top: 1rem solid #FFF; border-left: 1rem solid #FFF; border-right: 1rem solid #FFF;
 margin-left: 80rem;
  position: relative;
  padding-bottom: 15rem;
border-radius: 20rem 20rem 0 0;
background: linear-gradient(180deg, rgba(206, 235, 255, 0.50) 0%, rgba(147, 199, 255, 0.50) 121.94%);
 
width: 1760rem;
height: 80rem;
padding: 19rem 72rem;
align-items: center;
 
  .status {
    padding: 0 40rem;
   
    font-weight: 500;
    color: #50a9fc;
     
    color: var(--dark-87-ffffff, rgba(255, 255, 255, 0.87));

text-align: center;
 
font-size: 20rem;
font-style: normal;
font-weight: 600;
line-height: 30rem; /* 150% */
    position: relative;
    cursor: pointer;
  
  }
  img {
    // position: absolute;
    // right: 40rem;
    width: 36rem;
    height: 36rem;
  }
}
 .search {
      position: absolute;
      right: 105rem;
      gap: 50rem;
      display: flex;
      align-items: center;
      .btn {
       border-radius: 10rem;
border: 1rem solid var(--30-d-0-f-5, #30D0F5);
background: linear-gradient(104deg, #40CCFF 11.83%, #2196F3 100.74%);
        display: flex;
width: 125rem;
height: 50rem;
justify-content: center;
align-items: center;
gap: 8rem;
      
 
        font-size: 16rem;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }
      img {
        width: 20rem;
        height: 20rem;
        // margin-left: 40rem;
        cursor: pointer;
      }
    }
.active {
  // font-weight: bold !important;
  // color: #1372e9 !important;
 
       color: var(--dark-100-ffffff, #FFF) !important;
    
  &:after {
    content: "";
    position: absolute;
    width: 60rem;
    height: 5rem;
    background: #FFF;
    left: 62%;
    margin-left: -50rem;
    top: 35rem;
    border-radius: 3rem;
  }
}
.list {
  // width: 100%;
  padding: 0 40rem;
  margin: 0 auto;
  // height: calc(100% - 455rem);
  overflow-y: scroll;
 border-radius: 20rem 20rem 0 0;
border-top: 1rem solid #FFF;
border-right: 2rem solid #FFF;
border-left: 2rem solid #FFF;
background: rgba(233, 241, 252, 0.60);
  width: 1840rem;
height: 556rem;
  .post_item {
    // border: 5rem solid #3fa2ff;
    text-indent: 15rem;
    border-radius: 20rem;
    background: white;
    margin-top: 20rem;
    padding: 15rem;
    font-size: 24rem;
    position: relative;
    cursor: pointer;
    .head {
      position: relative;
      display: flex;
      font-size: 18rem;
      span {
        font-weight: bold;
        color: #000000;
      }
    }
    .tab {
            display: flex;
    height: 35rem;
    // width: 94rem;
    // padding: 5rem 13rem;
    padding-right: 11rem !important;
    // justify-content: center;  
    align-items: center;
    gap: 10px;
    position: absolute;
    right: 0px;
    padding-right: 3rem;
    border-radius: 0 20px;
    background: #F67171;
    color: #FFF;
    font-size: 12rem;
    font-style: normal;
    font-weight: 400;
    top: 0rem;
    }
    .content {
      font-weight: 500;
      color: #333333;
      font-size: 16rem;
      margin-top: 5rem;
    }
    /* .image {
      width: 64rem;
      height: 30rem;
      img {
        width: 64rem;
        height: 48rem;
        position: absolute;
        right: 20rem;
        top: 40rem;
      }
    } */
    .opertion {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14rem;
      font-weight: 400;
      color: #999;
      margin-top: 20rem;
      img {
        width: 18rem;
        height: 18rem;
      }
      .left {
        display: flex;
        align-items: center;
        margin-left: 18rem;
      }
      .right {
        color: var(--light-999999, #999);
font-size: 14rem;
font-style: normal;
font-weight: 400;
line-height: 30rem; /* 150% */
      }
    }
  }
}
.page {
  margin-left: 40rem;
  // margin-bottom: 78rem;
  // margin-top: 30rem;
  margin-top: 15rem;
  margin-bottom: 20rem;
}
:deep .ant-modal-content {
  overflow-x: inherit;
}
 
</style>